import { STATUS_OK, STATUS_INTERNAL_SERVER_ERROR } from "../constants";

/**
 * Default value for `validateStatus` option to prevent Axios from throwing non-5xx errors.
 */
export var validateStatus = function validateStatus(status) {
  return status >= STATUS_OK && status < STATUS_INTERNAL_SERVER_ERROR;
};
//# sourceMappingURL=validateStatus.js.map